import React, { Fragment } from "react"

import CustomFieldText from "./text"
import CustomFieldSelect from "./select"
import CustomFieldMultiselect from "./multiselect"
import CustomFieldBoolean from "./boolean"
import CustomFieldNumber from "./number"
import CustomFieldUrl from "./url"
import CustomFieldDate from "./date"

import type { CustomFieldUnion } from "@love-irish/types"

export const Component = ({ field }: { field: CustomFieldUnion }) => {
  if (!field.__typename) return null

  switch (field.__typename) {
    case "CustomFieldText":
      return <CustomFieldText field={field} />
    case "CustomFieldSelect":
      return <CustomFieldSelect field={field} />
    case "CustomFieldMultiselect":
      return <CustomFieldMultiselect field={field} />
    case "CustomFieldBoolean":
      return <CustomFieldBoolean field={field} />
    case "CustomFieldNumber":
      return <CustomFieldNumber field={field} />
    case "CustomFieldUrl":
      return <CustomFieldUrl field={field} />
    case "CustomFieldDate":
      return <CustomFieldDate field={field} />
    default:
      return null
  }
}

export default Component
